import React, { useState } from 'react';
import { Dropdown, Menu, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import Button from "antd/es/button";
import Modal from 'antd/lib/modal/Modal';
import RolesSelector from "./RolesSelector";
import { EditedUser } from "../../../Pages/Admin/Contracts/AdminContractEditionPage";

interface ActionButtonProps {
  onOk?: Function;
  onRemove: Function;
  record: any;
}

export default function ActionButton(props: ActionButtonProps) {
  const { onRemove, record, onOk } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editedUser, setEditedUser] = useState<EditedUser|undefined>(undefined);

  const onRoleEdition = (user: any, role: string, checked: boolean) => {
    const editedUser: EditedUser = { id: user.id };
    if (!user.contractRoles) {
      user.contractRoles = [];
    }

    if (checked) {
      user.contractRoles.push(role);
    } else {
      user.contractRoles = user.contractRoles.filter((current: string) => role !== current);
    }

    editedUser['contractRoles'] = Array.from(new Set(user.contractRoles));
    setEditedUser(editedUser);
  }

  const menu = <Menu
    items={[
      {
        label: <Button type={'link'} onClick={() => onRemove && onRemove(record)}>remove</Button>,
        key: '0',
      },
      {
        label: <Button type="link" onClick={() => setIsModalVisible(true)}>edit roles</Button>,
        key: '1',
      },
    ]}
  />

  return (
    <div>
      <Modal
        title="Edit roles"
        open={isModalVisible}
        onOk={() => {setIsModalVisible(false); onOk && onOk(editedUser);}}
        onCancel={() => setIsModalVisible(false)}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <RolesSelector user={record.value} onChange={onRoleEdition} />
      </Modal>
      <Dropdown overlay={menu} trigger={['click']}>
        <a onClick={e => e.preventDefault()}>
          <Space>
            actions
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
    </div>
  );
}